/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import SubAdminList from "./features/subadminlist";

const SubAdmin = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <SubAdminList />
        </section>
      </Layout>
    </>
  );
};
export default SubAdmin;
